<template>
	<textarea :placeholder=placeholder :disabled=disabled class="materialize-textarea" v-model="textLocal"></textarea>
</template>
<script>
import axios from 'axios';
import _ from 'lodash';
export default {
  data: function () {
    return {}
  },
  mounted: function(){
    M.textareaAutoResize(this.$el);
  },
  model: {
    prop: 'text',
    event: 'textchange'
},
methods: {
  textInput: function(event){
    this.textLocal = event.target.textContent
  }
},
   props: { text: String, placeholder: String, disabled: Boolean },
  computed: {
     textLocal: {
      get: function(){
        return this.text
      },
      set: function(value){
        M.textareaAutoResize(this.$el);
        this.$emit('textchange', value)
      }
    },
  },
  
}
</script>
<style scoped>
div {
  min-height: 32px;
  line-height: 1.15;
  background-color: white !important;
  border-radius: 4px !important;
  border-width: 1px !important;
  border-style: solid !important;
  border-color: rgb(140, 140, 140) !important;
  padding: 5px !important;
}
.emptycontent {
  color:  grey;
}
</style>